<template>
    <div>
        <strong>Terms and Conditions</strong><br>
        <p>These terms and conditions apply to the Serene application (referred to as the "Application") for mobile
            devices, created by Quiz & Games Online (referred to as the "Service Provider") as a Freemium service.</p>
        <br>
        <p>By downloading or using the Application, you automatically agree to the following terms. It is strongly
            recommended that you read and understand these terms before using the Application. Unauthorized copying,
            modification of the Application, any part of the Application or our trademarks is strictly prohibited.
            Attempts to extract the source code of the Application, translate it into other languages or create
            derivative versions thereof are also not permitted. All trademarks, copyrights, database rights and other
            intellectual property rights related to the Application remain the property of the Service Provider.</p>
        <br>
        <p>The Service Provider is committed to ensuring that the Application is as useful and efficient as possible.
            Therefore, it reserves the right to modify the Application or charge for its services at any time and for
            any reason. The Service Provider ensures that any charges for the Application or its services will be
            clearly communicated to you.</p>
        <br>
        <p>The Application stores and processes personal data that you have provided to the Service Provider in order to
            provide the Service. It is your responsibility to maintain the security of your phone and access to the
            Application. The Service Provider strongly recommends that you avoid jailbreaking or rooting your phone,
            actions that involve removing software restrictions imposed by the device's official operating system. Such
            actions may expose your phone to malware, viruses, malicious programs, compromise the device's security
            features and result in the Application malfunctioning or completely inoperable.</p>
        <div>
            <p>The Application uses third-party services that have their own Terms and Conditions. Below are links to
                the Terms and Conditions of the third-party service providers used by the Application:</p>
            <ul>
                <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google Play
                        Services</a></li>
                <li><a href="https://developers.google.com/admob/terms" target="_blank"
                        rel="noopener noreferrer">AdMob</a></li>
                <li><a href="https://www.google.com/analytics/terms/" target="_blank" rel="noopener noreferrer">Google
                        Analytics for Firebase</a></li>
                <li><a href="https://firebase.google.com/terms/crashlytics" target="_blank"
                        rel="noopener noreferrer">Firebase Crashlytics</a></li>
                <li><a href="https://onesignal.com/tos" target="_blank" rel="noopener noreferrer">One Signal</a></li>
                <li><a href="https://www.revenuecat.com/terms" target="_blank" rel="noopener noreferrer">RevenueCat</a>
                </li>
            </ul>
        </div>
        <br>
        <p>The Service Provider assumes no liability for certain aspects. Some functions of the Application require an
            active internet connection, either via Wi-Fi or provided by your mobile network provider. The Service
            Provider is not liable if the Application does not function fully due to lack of Wi-Fi access or if you have
            exhausted your data allowance.</p>
        <br>
        <p>If you use the Application outside of a Wi-Fi area, please be aware that the terms of your agreement with
            your mobile network provider still apply. You may incur charges from your mobile network provider for data
            usage while connected to the Application, or other third party charges. By using the Application, you accept
            responsibility for these charges, including roaming charges if you use the Application outside of your
            region or country without disabling data roaming. If you are not the account holder for the device, we
            assume that you have obtained permission from the account holder.</p>
        <br>
        <p>In addition, the Service Provider cannot always assume responsibility for your use of the Application. For
            example, it is your responsibility to ensure that your device is charged. If your device runs out of battery
            and you are unable to access the Service, the Service Provider will not be liable.</p>
        <br>
        <p>With respect to the Service Provider's liability for your use of the Application, it is important to note
            that while the Service Provider makes every effort to keep the Application up to date and accurate, it
            relies on third parties to provide information that is made available to you. The Service Provider shall not
            be liable for any loss, direct or indirect, that you may suffer by relying entirely on this functionality of
            the Application.</p>
        <br>
        <p>The Service Provider may update the Application from time to time. The Application is currently available
            subject to the requirements of the operating system (and any additional systems to which they decide to
            extend the availability of the Application) may change. You will need to download updates if you wish to
            continue using the Application. The Service Provider does not guarantee that it will always update the
            Application so that it is relevant to you or compatible with the version of the operating system installed
            on your device. However, you agree to always accept updates when offered. The Service Provider may also
            decide to cease providing the Application and may terminate your use of the Application at any time without
            notice. Unless otherwise stated, upon termination, (a) the rights and licenses granted to you in these terms
            will terminate; (b) you must stop using the Application and, if necessary, delete it from your device.</p>
        <br><strong>Changes to the Terms and Conditions</strong>
        <p>The Service Provider may periodically update its Terms and Conditions. Accordingly, you are advised to review
            this page regularly for changes. The Service Provider will notify you of any changes by posting the new
            Terms and Conditions on this page.</p>
        <br>
        <p>These terms and conditions are valid from January 12, 2025.</p>
        <br><strong>Contact Us</strong>
        <p>If you have any questions or suggestions about the Terms and Conditions, do not hesitate to contact the
            Service Provider by email: quizejogosonline@gmail.com.</p>
    </div>
</template>

<script>
export default {
    name: "SereneTermsAndConditionsEN"
}
</script>